<top-bar-tabs></top-bar-tabs>
@if (fundService.loaded$ | async) {
  <div class='container-background'>
    <!--  <fund-page-buttons></fund-page-buttons>-->
    <fund-information [fund]="fund" [statuses]="fundService.sequenceStatuses$ | async" [types]="fundService.fundTypes$ | async" [isCertificated]="isCertificated" (save)="updateFund($event)" [permissions]="fundService.permissions$ | async"></fund-information>
    <fund-participants [participants]="(fundService.participants$ | async) || {}"
      [CREARoles]="(fundService.CREAParticipantRoles$ | async) || []"
      [thirdPartyRoles]="(fundService.thirdParticipantRoles$ | async) || []"
      (save)="updateParticipants($event)"
      (delete)="removeParticipant($event)"
      [permissions]="fundService.permissions$ | async"
    ></fund-participants>
    @if (!isCertificated) {
      <fund-investors [investors]="(fundService.investors$ | async) || []" [classes]="(fundService.investmentClasses$ | async) || []" (save)="updateInvestor($event)" [permissions]="fundService.permissions$ | async"></fund-investors>
    }
    <fund-credits-table [outlets]="(fundService.outlets$ | async) || {}"
      [fundProjectStates]="(fundService.fundProjectStates$ | async) || []"
      [statusSequences] = "(fundService.syndicationsSequences$ | async) || []"
      (update)="updateProjectCredit($event)"
      (save)="createProjectCredit($event)"
      (remove)="removeFundCredit($event)"
      (subscribe)="refetchData($event)"
    [permissions]="fundService.permissions$ | async"></fund-credits-table>
    @if (!isCertificated) {
      <fund-budgeted-revenue [budgetDetails]="fund.syndicationsDetails" (save)="updateRevenueYear($event)" [permissions]="fundService.permissions$ | async"></fund-budgeted-revenue>
    }
  </div>
}
